var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBloodOxygen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blood-oxygen_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".blood-oxygen_svg__st0,.blood-oxygen_svg__st1{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-miterlimit:10}.blood-oxygen_svg__st1{stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "blood-oxygen_svg__st0",
    d: "M12 115.7h29.5M25 131.4h104.7M101.5 34.7h20M92 16.6h44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "blood-oxygen_svg__st1",
    d: "M67.8 89.2c-4.1 0-7.3-3.3-7.3-7.3v-9.6c0-4.1 3.3-7.3 7.3-7.3 4.1 0 7.3 3.3 7.3 7.3v9.6c.1 4.1-3.2 7.3-7.3 7.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.1 84.1c0-19.4-35.1-67.5-35.1-67.5S39.8 64.7 39.8 84.1s15.7 35.1 35.1 35.1 35.2-15.7 35.2-35.1z",
    fill: "none",
    stroke: "var(--color-text)",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1 45.3l1.5 5.4C92.3 57.6 94.5 70 92 82c.5 1 .7 2.1.7 3.3 0 3.1-1.7 5.7-4.2 7.1-.3.6-.6 1.2-1 1.8h2.2c1.8 0 3.3 1.5 3.3 3.3s-1.5 3.3-3.3 3.3h-7.1c-4.8 5.1-11.6 9.2-21.1 11.4 4.1 1.9 8.6 3 13.2 3 10.5 0 19.8-5.2 25.4-13.2 3.8-5 5.9-11.2 5.9-17.8 0-8.6-8.1-24.4-16.9-38.9z",
    fill: "var(--color-icon-secondary)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "blood-oxygen_svg__st1",
    d: "M89.9 97.5H82c.2-1.8 1.3-3.4 2.5-4.8s2.6-2.6 3.5-4.2 1.4-3.6.5-5.3c-.4-.8-1-1.4-1.8-1.8-1.3-.6-3-.4-4 .5 0 0-.8.4-1.4 2.5"
  })));
}
export default SvgBloodOxygen;